// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface ZoomStyles {
    zoomContainerStyles?: InjectableCss;
}

export const imageZoomStyles: ZoomStyles = {
    zoomContainerStyles: {
        css: css`
            .iiz {
                max-width: 100%;
                margin: 0;
                position: relative;
                overflow: hidden;
                display: inline-block;
                cursor: -webkit-zoom-in;
                cursor: zoom-in;
            }

            .iiz--drag .iiz__zoom-img--visible {
                cursor: -webkit-grab;
                cursor: grab;
            }

            .iiz__img {
                max-width: 100%;
                height: auto;
                display: block;
                pointer-events: none;
                visibility: visible;
                opacity: 1;
            }

            .iiz__img--hidden {
                visibility: hidden;
                opacity: 0;
            }

            .iiz__img--abs {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                display: block;
            }

            .iiz__zoom-img {
                width: auto !important;
                max-width: none !important;
                max-height: none !important;
                position: absolute;
                visibility: hidden;
                opacity: 0;
                display: block;
            }

            .iiz__zoom-img--visible {
                visibility: visible;
                opacity: 1;
                cursor: -webkit-zoom-out;
                cursor: zoom-out;
            }

            .iiz__zoom-portal {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 10000;
            }

            .iiz__btn {
                display: none;
            }
        `,
    },
};
